<flx-resources-grid
  [hasBackground]="false"
  [inputGridOptions]="gridOptions()"
  [tableDef]="workflowsTableCols"
  [uniqueKeys]="['id']"
  [emptyMsg]="'No workflows found'"
  (gridReady)="onGridReady($event)"
/>

<ng-template
  [flxShowModal]="showDetailsModal()"
  panelClass="w-[80%] h-[90%] flx-instance-workflows-panel"
>
  <flx-workflow-instance-details-modal (hideModal)="hideDetailsModal()" />
</ng-template>
